export default __webpack_public_path__ + "static/media/weeds.b991ad15.png";